const RisksIcon = ({color}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_602_25147)">
        <path
          d="M10.239 3.95647L1.81704 18.0165C1.64352 18.3172 1.55172 18.6581 1.55079 19.0052C1.54985 19.3524 1.63981 19.6938 1.81171 19.9954C1.98361 20.2971 2.23147 20.5484 2.53064 20.7246C2.82982 20.9007 3.16989 20.9955 3.51704 20.9995H20.362C20.7092 20.9955 21.0493 20.9007 21.3484 20.7246C21.6476 20.5484 21.8955 20.2971 22.0674 19.9954C22.2393 19.6938 22.3292 19.3524 22.3283 19.0052C22.3274 18.6581 22.2356 18.3172 22.062 18.0165L13.639 3.95647C13.4617 3.66446 13.2121 3.42306 12.9143 3.25553C12.6166 3.088 12.2807 3 11.939 3C11.5974 3 11.2615 3.088 10.9637 3.25553C10.666 3.42306 10.4164 3.66446 10.239 3.95647Z"
          stroke={color || "#669386"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 9V13"
          stroke={color || "#669386"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17H12.01"
          stroke={color || "#669386"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_602_25147">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RisksIcon;
